'use client';

import { useRouter } from 'next/navigation';
import { useI18n } from '@fshr/context/i18n-context';

import { Button } from '@fshr/components';
import { Empty } from '@fshr/microservices/compiled/profile.v1';
import { cn } from '@fshr/shared-react';

interface SignOutButtonProps {
	size?: 'small' | 'medium' | null | undefined;
	onSignOut?: () => void;
	className?: string;

	signOut: () => Promise<Empty>;
}

export default function SignOutButton({
	size = 'small',
	onSignOut,
	className,
	signOut,
}: SignOutButtonProps) {
	const { t, localeLink } = useI18n();
	const router = useRouter();

	const handleClick = () => {
		signOut().then(() => {
			onSignOut && onSignOut();
			router.push(localeLink('/'));
		});
	};

	return (
		<Button
			intent="text"
			size={size}
			className={cn('border-none', className)}
			onClick={handleClick}
		>
			{t('Sign Out')}
		</Button>
	);
}
